import React from 'react';
import { css, cx } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { CrossIcon } from '@pocket/web-ui';
export const tagBase = "trxac13";
export const tagWrapper = "t9ef2pv";
const closeWrapper = "cn6urtm";
export function Tag({
  removeClick,
  selectClick,
  children,
  selected,
  margin
}) {
  const onRemoveClick = e => {
    e.stopPropagation();
    if (removeClick) removeClick(children);
  };

  const onSelectClick = () => selectClick ? selectClick(children) : null;

  const action = selectClick ? true : false;
  const tagClass = cx(tagBase, tagWrapper, action && 'action', selected && 'selected');
  const removeClass = cx(buttonReset, closeWrapper, selected && 'selected');
  return <div className={tagClass} style={{
    margin
  }} onClick={onSelectClick}>
      {children}
      {removeClick ? <button className={removeClass} onClick={onRemoveClick}>
          <CrossIcon />
        </button> : null}
    </div>;
}

require("./tag.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag.js");